module.exports = __webpack_public_path__ + "static/media/descendingIcon.25c8db24.svg";